import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import { mathVaultSanity } from '~/shared/sanity/math-vault'
import { AppLanguage } from '~/types/locale'
import { MathVaultChestIdsMap } from '~/types/math-vault'

interface ChestIdMappedModel {
  [key: string]: string
}

const formatData = (data: MathVaultChestIdsMap[]): ChestIdMappedModel => {
  const newData: ChestIdMappedModel = {}
  data.forEach((room) => {
    room.chests.forEach((chest) => (newData[chest.id] = `${room.elevatorKey}/${room.roomKey}/${chest.key}`))
  })
  return newData
}

const useChestIdsMapped = (): { chestIdMapped: ChestIdMappedModel } => {
  const [chestIdMapped, setChestIdMapped] = useState<ChestIdMappedModel>({})
  const language = useRouter().locale
  useEffect(() => {
    mathVaultSanity.getJuniorDrillChestIds(language as AppLanguage).then((data) => {
      setChestIdMapped(formatData(data))
    })
  }, [language])

  return { chestIdMapped } as const
}

export default useChestIdsMapped
